/**
 * Utility functions for the meetings query layout
 */

// Regular expression for cleaning HTML tags, Markdown formatting, and normalizing spaces
const HTML_MARKDOWN_CLEANUP_REGEX = /(<[^>]*>)|(^[\s]*[-*+][\s]+|[*_~`#]|\[|\]|\(|\)|^\s*>)|( {2,}|\t+)/gm;

// Action types imported directly to avoid circular dependencies
export const ACTION = {
  SUMMARIZE: 'SUMMARIZE',
  QUERY: 'QUERY',
  ANECDOTES: 'ANECDOTES',
};

/**
 * Formats the chat history array into a well-formatted string that matches the UI rendering
 * @param {Array} chatHistory - Array of chat entries with label, value, and type
 * @returns {string} - Formatted string representation of the chat history
 */
export const formatChatHistoryToString = (chatHistory) => {
  if (!chatHistory || chatHistory.length === 0) {
    return '';
  }

  return chatHistory.map((entry) => {
    // For divider entries that contain gray line HTML, skip them entirely
    if (!entry.label && entry.type === 'DIVIDER' &&
        entry.value && entry.value.includes("<hr style='border: 0")) {
      return '';
    }
    
    // For non-divider entries, process the value
    let entryValue = entry.value;
    if (entryValue && typeof entryValue === 'string') {
      // Single regex to remove HTML tags, Markdown formatting, and normalize spaces
      // while preserving line breaks
      entryValue = entryValue.replace(
        HTML_MARKDOWN_CLEANUP_REGEX,
        (match, htmlTag, markdown, spaces) => {
          // If it's extra spaces or tabs, replace with a single space
          if (spaces) return ' ';
          // If it's HTML tag or Markdown formatting, remove it
          return '';
        }
      );
    }

    // Format the label based on the entry type
    let formattedLabel = '';
    if (entry.type === ACTION.QUERY) {
      formattedLabel = `Q: ${entry.label}`;
    } else if (entry.type === ACTION.SUMMARIZE) {
      formattedLabel = `Action: ${entry.label}`;
    } else {
      formattedLabel = entry.label;
    }

    // If there's no value or it's a loading indicator, just return the label
    if (!entryValue || entryValue === '...' || entryValue === 'Generating your response ...') {
      return `${formattedLabel}\n`;
    }

    // Return the formatted entry
    return `${formattedLabel}\n${entryValue}\n`;
  }).join('\n');
};